import type { RepoBranch, StudioBranchesActions } from '../../actions/studio/branches';
import { RESET_STUDIO_ACTION } from '../consts';

export interface State {
    isFetchingRepoBranches: boolean;
    repoBranches: RepoBranch[] | null;
    fetchProjectRepoBranchesError: Error | null;
}

const getDefaultState = (): State => ({
    /**
     * Is project repo branches being updated of fetched
     */
    isFetchingRepoBranches: false,

    /**
     * Project repo branches
     */
    repoBranches: null,

    /**
     * Get project repo branches error
     */
    fetchProjectRepoBranchesError: null
});

const branchesReducer = (state = getDefaultState(), action: StudioBranchesActions | null): State => {
    switch (action?.type) {
        case 'GET_PROJECT_REPO_BRANCHES_STARTED': {
            return {
                ...state,
                fetchProjectRepoBranchesError: null,
                isFetchingRepoBranches: true
            };
        }

        case 'GET_PROJECT_REPO_BRANCHES_DONE': {
            const { repoBranches } = action.data;

            return {
                ...state,
                repoBranches,
                isFetchingRepoBranches: false
            };
        }

        case 'GET_PROJECT_REPO_BRANCHES_FAILED': {
            return {
                ...state,
                fetchProjectRepoBranchesError: action.data.error,
                isFetchingRepoBranches: false
            };
        }

        case RESET_STUDIO_ACTION: {
            return getDefaultState();
        }

        default: {
            return state;
        }
    }
};

export default branchesReducer;
